import type { RouteStatus } from './metroMapStore'
import { resolveRouteCardClock } from './routeCardClock'

/**
 * The clock the route card and route details count a route's times from:
 * the instant the routes were planned to leave (`RouteStatus.results`
 * `departsAt` — Night Tube mode plans for the next night window), else the
 * test seam (`resolveRouteCardClock`), else the components' own `new Date()`.
 * Counting a night route from now showed today's afternoon times for a
 * journey planned at 00:30.
 */
export function routeTimesClock(status: RouteStatus): (() => Date) | undefined {
  if (status.kind === 'results' && status.departsAt !== undefined) {
    const departsAt = new Date(status.departsAt)
    return () => departsAt
  }
  return resolveRouteCardClock()
}
